import Image from "next/image";

export const CityImage = ({ location }) => {
  return (
    <>
      {location === "Berlin" && (
        <Image
          src="/images/talentpool/cities/berlin.jpg"
          alt="background image event city"
          className="select-none"
          layout="fill"
          quality={100}
          objectPosition="contain"
          objectFit="cover"
        />
      )}
      {location === "Dresden" && (
        <Image
          src="/images/talentpool/cities/dresden.jpg"
          alt="background image event city"
          className="select-none"
          layout="fill"
          quality={100}
          objectPosition="contain"
          objectFit="cover"
        />
      )}
      {location === "Hamburg" && (
        <Image
          src="/images/talentpool/cities/hamburg.jpg"
          alt="background image event city"
          layout="fill"
          className="select-none"
          quality={100}
          objectPosition="contain"
          objectFit="cover"
        />
      )}
      {location === "Köln" && (
        <Image
          src="/images/talentpool/cities/cologne.jpg"
          alt="background image event city"
          layout="fill"
          className="select-none"
          quality={100}
          objectPosition="contain"
          objectFit="cover"
        />
      )}
      {location === "Frankfurt" && (
        <Image
          src="/images/talentpool/cities/frankfurt.jpg"
          alt="background image event city"
          layout="fill"
          className="select-none"
          quality={100}
          objectPosition="contain"
          objectFit="cover"
        />
      )}
      {location === "München" && (
        <Image
          src="/images/talentpool/cities/munich.jpg"
          alt="background image event city"
          layout="fill"
          className="select-none"
          quality={100}
          objectPosition="contain"
          objectFit="cover"
        />
      )}
      {location === "Stuttgart" && (
        <Image
          src="/images/talentpool/cities/stuttgart.jpg"
          alt="background image event city"
          layout="fill"
          className="select-none"
          quality={100}
          objectPosition="contain"
          objectFit="cover"
        />
      )}
      {location === "Düsseldorf" && (
        <Image
          src="/images/talentpool/cities/duesseldorf.jpg"
          alt="background image event city"
          layout="fill"
          className="select-none"
          quality={100}
          objectPosition="contain"
          objectFit="cover"
        />
      )}
      {location === "Digital" && (
        <Image
          src="/images/talentpool/cities/digital.jpg"
          alt="background image event city"
          layout="fill"
          quality={100}
          objectPosition="contain"
          objectFit="cover"
        />
      )}
    </>
  );
};
